<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <span class="subtitle-1">Path</span>
                <br />
                <span v-for="(folder, i) in path" :key="folder.name">
                  <span v-if="i !== 0" class="mx-1"><small>/</small></span>
                  <span>{{ folder.name }}</span>
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field v-model="form.name" label="Name" />
              </v-col>
            </v-row>
            

            <v-row>
              <v-col>
                <PermissionSelect v-model="permissions" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import PermissionSelect from "components/PermissionSelect";

const defaultInputs = {
  id: 0,
  accountId: 0,
  name: "",
  notes: "",
};

export default {
  components: {
    AlertMessage,
    PermissionSelect,
  },
  props: {
    clientId: Number,
    item: Object,
    path: Array,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      id: {},
      accountId: {},
      name: { required },
    },
  },
  validationMessages: {
    form: {
      id: {},
      clientId: { required: "Required" },
      accountId: {},
      name: { required: "Required" },
    },
  },

  data() {
    return {
      showDialog: this.show,
      form: {
        ...defaultInputs,
      },
      dialog: false,
      valid: false,
      loading: false,
      fileValue: undefined,
      fileLoaded: 0,
      permissions: [],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        this.form = {
          ...newTask,
        };
        this.permissions = newTask.permissions;
      } else {
        this.permissions = this.defaultItems;
        this.form = {
          ...defaultInputs,
          permissions: this.defaultItems,
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      user: (state) => state.account.data.user,
      userGroups: (state) => state.userGroup.data,
      passwordVault: (state) => state.passwordVault,
      alert: (state) => state.alert,
    }),

    defaultItems() {
      let items = [];
      this.userGroups.forEach((item) => {
        const isAdmin = item.name === "Super Admin"
        const isIntendant = item.name === "Superintendant"
        const isManager = item.name === "Field Manager"

        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 1, // view access
          access: true
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 3, // edit access
          access: isAdmin || isIntendant || isManager
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 4, // delete access
          access: isAdmin
        });
      });
      return items;
    },
    getAdminGroup() {
      let found = this.userGroups.filter((item) => item.name == "Super Admin");
      if (found.length === 1) {
        return found[0];
      } else {
        return null;
      }
    },
    formTitle() {
      return this.isEdit ? `Edit Folder ${this.item.name}` : "New Folder";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    taskId() {
      return UTIL.gv(this.item, "id", "");
    },
    folderId() {
      const folderId = this.path[this.path.length - 1].id;
      return folderId;
    },
  },

  methods: {
    ...mapActions("storageFolder", ["create", "update"]),

    initForm() {
      if (this.clientId) {
        this.form = {
          ...this.form,
        };
      }
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.permissions = [];
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.permissions = [];
      this.$emit("onSucceded");
    },

    readFile() {
      this.fileLoaded = 0;
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        const result = event.target.result;
        this.fileValue = result;
        // Do something with result
      });

      reader.addEventListener("progress", (event) => {
        if (event.loaded && event.total) {
          const percent = (event.loaded / event.total) * 100;
          this.fileLoaded = Math.round(percent);
        }
      });
      if (this.form.file) {
        reader.readAsDataURL(this.form.file);
      }
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
        parentId: this.folderId >= 0 ? this.folderId : null,
        permissions: this.permissions,
      };

      if (this.isEdit) {
        await this.update({
          id: this.taskId,
          ...payload,
        });
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.passwordVault.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>